import { spacesToProperty } from '../general'

export const validateProcedureCode = (value: any, formData: any, name: any) => {
  const isValid = /^[D|T]\d{4}$/.test(value)
  if (value === '') return `${spacesToProperty(name)} is required`
  return value && !isValid && 'e.g. D1110'
}
